
import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormInput,
  CButton
} from '@coreui/react-pro'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormTextInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  placeholder,
  value,
  handleTextInput,
  feedbackInvalid,
  invalid,
  combinationIndex,
  disabled,
  isShowButton = false,
  buttonLabel,
  handleClickButton,
  autoFocus = false
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      )}
      {
        isShowButton && (
          <CButton
            onClick={() => handleClickButton()}
            style={styleButtonVars2}
            className='ms-2'
            size='sm'
          >
              {buttonLabel}
          </CButton>
        )
      }
      <CFormInput
        id={id}
        name={name}
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e) => handleTextInput(e, combinationIndex)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </CCol>
  )
}

export default FormTextInput
